module.exports = __webpack_public_path__ + "static/splittable-home-fe9361f8cd52c131013a0e6183a8b4da.png";